export const ACTION_FETCH = 'fetch';
export const STORE_MODULE_NAME = 'inquiry';
export const CHILD_TITLE = 'Как подтвердить данные обучающегося';
export const CERT_TITLE =
  'Как активировать сертификат и получить средства на счет';
export const ERROR_DEFAULT_TEXT =
  'В настоящий момент правила в вашем муниципальном районе не утверждены, пожалуйста, проверьте правила позже.';
export const INFO_TEXT = 'Действительно для:';



// WEBPACK FOOTER //
// ./src/pages/inquiry/const.ts